module.exports = __webpack_public_path__ + "img/est.543cfa7e.svg";